import axios from 'axios'
import { locale } from '@/i18n'

const axiosInstance = axios.create({
        baseURL: '/api',
        withCredentials: true,
})

axiosInstance.interceptors.request.use(
        config => {
                const token = localStorage.getItem('userToken')
                if (token) {
                        config.headers.Authorization = `Bearer ${token}`
                }
                config.headers['X-Language'] = locale.value
                return config
        },
        error => {
                return Promise.reject(error)
        }
)

// Обработка ответа, например редирект при 401
axiosInstance.interceptors.response.use(
        response => response,
        async error => {
                return Promise.reject(error)
        }
)

export default axiosInstance
